import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getTestProps } from '../../../lib/helpers';

import useSelectedSpace from '../../../hooks/useSelectedSpace';

import { DuplicateSolidIcon } from '../../../images/shapes';

import PopoverItem from '../../Popover/PopoverItem/PopoverItem';

const DuplicateSelectedButton = ({
  checkedRows,
  contentTypeName,
  limitReached,
  testId,
}) => {
  const { t } = useTranslation();
  const { buildUrlWithSpace } = useSelectedSpace();
  return (
    <PopoverItem
      link={
        contentTypeName === '_webhooks'
          ? buildUrlWithSpace(`webhooks/duplicate/${checkedRows[0]}`)
          : buildUrlWithSpace(
              `content-type-objects/duplicate/${contentTypeName}/${checkedRows[0]}`,
            )
      }
      buttonSize="sm"
      buttonColor="borderless"
      iconPosition="start"
      label={t('Global.Duplicate')}
      iconImage={
        <DuplicateSolidIcon className="w-3 text-blue dark:text-white" />
      }
      color="blue"
      disabled={!!limitReached}
      {...getTestProps(testId, 'duplicate-data', 'testId')}
    />
  );
};

DuplicateSelectedButton.propTypes = {
  /**
   * Array of checked rows
   */
  checkedRows: PropTypes.array,
  /**
   * Content type name
   */
  contentTypeName: PropTypes.string,
  /**
   * Is limit reach
   */
  limitReached: PropTypes.string,
  /**
   * Test id
   */
  testId: PropTypes.string,
};

export default DuplicateSelectedButton;
